// import jsPDF from 'jspdf'

// const DEFAULT_HOTEL = {
//   name: 'Nityanand',
//   address: 'Shop No-5, Shukla Estate, S.V Road Oshiwara, Opp Ajit Glass Jogeshwari(W), Mumbai 400102',
//   phone: '',
//   gst: '',
// }

// const formatDateTime = (d = new Date()) => {
//   const pad = (n) => String(n).padStart(2, '0')
//   const hours = d.getHours()
//   const h12 = hours % 12 || 12
//   const ampm = hours >= 12 ? 'PM' : 'AM'
//   return {
//     date: `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${String(d.getFullYear()).slice(2)}`,
//     time: `${pad(h12)}:${pad(d.getMinutes())} ${ampm}`,
//   }
// }

// const money = (value) => Number(value || 0).toFixed(2)

// const dashedLine = (doc, x1, y, x2) => {
//   doc.setDrawColor(0, 0, 0)
//   doc.setLineWidth(0.2)
//   const dashLen = 1.5
//   const gapLen  = 1.2
//   let cx = x1
//   while (cx < x2) {
//     doc.line(cx, y, Math.min(cx + dashLen, x2), y)
//     cx += dashLen + gapLen
//   }
// }

// const solidLine = (doc, x1, y, x2) => {
//   doc.setDrawColor(0, 0, 0)
//   doc.setLineWidth(0.3)
//   doc.line(x1, y, x2, y)
// }

// export const generateBillPdf = ({
//   type = 'normal',
//   hotel = DEFAULT_HOTEL,
//   bill = {},
//   tableId,
//   items = [],
//   subtotal = 0,
//   discount = 0,
//   tax = 0,
//   total = 0,
//   parcelChargeTotal = 0,
//   additionalChargeTotal = 0,
//   acChargeTotal = 0,
//   note = '',
//   paymentMode = 'Cash',
//   openInNewTab = true,
// }) => {
//   if (!items.length) return

//   const isDuplicate = type === 'duplicate'
//   const isKitchen  = type === 'kitchen'

//   const pageWidth   = 80
//   const left        = 5
//   const right       = pageWidth - 5
//   const center      = pageWidth / 2
//   const usableWidth = pageWidth - 10

//   // Parcel qty — same logic as original
//   const parcelQty = items.reduce((sum, item) => {
//     return sum + (Number(item.is_parcel || 0) === 1 ? Number(item.qty || 0) : 0)
//   }, 0)

//   // Totals row count — same as original
//   const totalsRowCount = isKitchen
//     ? 0
//     : 1 +
//       (parcelChargeTotal > 0 ? 1 : 0) +
//       (additionalChargeTotal > 0 ? 1 : 0) +
//       (acChargeTotal > 0 ? 1 : 0) +
//       (discount > 0 ? 1 : 0) +
//       (tax > 0 ? 1 : 0) +
//       1

//   const noteHeight = note ? 12 : 0
//   const baseHeight = isKitchen
//     ? 80 + noteHeight
//     : 130 + totalsRowCount * 6 + noteHeight
//   const pageHeight = baseHeight + items.length * 7

//   const doc = new jsPDF({
//     orientation: 'portrait',
//     unit: 'mm',
//     format: [pageWidth, pageHeight],
//   })

//   doc.setTextColor(0, 0, 0)

//   const setFont = (size = 8, style = 'normal') => {
//     doc.setFont('courier', style)
//     doc.setFontSize(size)
//   }

//   const { date: printDate, time: printTime } = formatDateTime(new Date())
//   const billNo    = bill?.bill_no || `BILL-${bill?.id || '000'}`
//   const tableName = bill?.table_name || `Table ${tableId || '0'}`

//   let y = 8

//   // ── HOTEL HEADER ──
//   setFont(13, 'bold')
//   doc.text(hotel.name.toUpperCase(), center, y, { align: 'center' })
//   y += 5

//   setFont(8, 'normal')
//   doc.text('Restaurant & Bar', center, y, { align: 'center' })
//   y += 4

//   doc.splitTextToSize(hotel.address || '', usableWidth).forEach((line) => {
//     doc.text(line, center, y, { align: 'center' })
//     y += 4
//   })

//   if (hotel.phone) {
//     doc.text(hotel.phone, center, y, { align: 'center' })
//     y += 4
//   }

//   y += 1
//   dashedLine(doc, left, y, right)
//   y += 4

//   // ── DUPLICATE BADGE ──
//   if (isDuplicate) {
//     setFont(7, 'bold')
//     doc.text('** DUPLICATE COPY **', center, y, { align: 'center' })
//     y += 4
//     dashedLine(doc, left, y, right)
//     y += 4
//   }

//   // ── CASH MEMO / KITCHEN ORDER ──
//   setFont(8, 'normal')
//   doc.text(
//     isKitchen ? '- - - - Kitchen Order - - - -' : '- - - - - Cash Memo - - - - -',
//     center, y, { align: 'center' }
//   )
//   y += 5

//   dashedLine(doc, left, y, right)
//   y += 4

//   // ── BILL META ──
//   setFont(7.5, 'normal')
//   doc.text(`Date : ${printDate}`, left, y)
//   doc.text(`Bill No. : ${billNo}`, right, y, { align: 'right' })
//   y += 4
//   doc.text(`T.No.: ${tableName}`, left, y)
//   if (!isKitchen) {
//     doc.text(`Payment: ${paymentMode}`, right, y, { align: 'right' })
//   }
//   y += 3

//   dashedLine(doc, left, y, right)
//   y += 4

//   // ── COLUMN HEADERS ──
//   // Layout: | Particulars ........... Qty  Rate  Amount |
//   const qtyX  = right - 30   // Qty column center
//   const rateX = right - 16   // Rate column center
//   const amtX  = right        // Amount right edge

//   setFont(8, 'bold')
//   doc.text('Particulars', left, y)
//   if (isKitchen) {
//     doc.text('QTY', amtX, y, { align: 'right' })
//   } else {
//     doc.text('Qty',    qtyX,  y, { align: 'center' })
//     doc.text('Rate',   rateX, y, { align: 'center' })
//     doc.text('Amount', amtX,  y, { align: 'right' })
//   }
//   y += 2
//   solidLine(doc, left, y, right)
//   y += 4

//   // ── ITEMS ──
//   setFont(8, 'normal')
//   const nameColWidth = isKitchen ? usableWidth - 10 : qtyX - left - 2

//   items.forEach((item) => {
//     const name      = `${item.name || '-'}${Number(item.is_parcel || 0) === 1 ? ' (Parcel)' : ''}`
//     const nameLines = doc.splitTextToSize(name, nameColWidth)
//     const lastLineY = y + (nameLines.length - 1) * 4.5

//     nameLines.forEach((line, idx) => {
//       doc.text(line, left, y + idx * 4.5)
//     })

//     if (isKitchen) {
//       doc.text(String(item.qty), amtX, y, { align: 'right' })
//     } else {
//       doc.text(String(item.qty),                                          qtyX,  lastLineY, { align: 'center' })
//       doc.text(money(item.price),                                         rateX, lastLineY, { align: 'center' })
//       doc.text(money(Number(item.qty || 0) * Number(item.price || 0)),    amtX,  lastLineY, { align: 'right'  })
//     }

//     y += nameLines.length * 4.5 + 1
//   })

//   // ── TOTALS SECTION (normal / duplicate only) ──
//   if (!isKitchen) {
//     y += 2
//     dashedLine(doc, left, y, right)
//     y += 4

//     // Helper: label at right-of-center, value at far right
//     const totRow = (label, value, bold = false, redLabel = false) => {
//       setFont(8, bold ? 'bold' : 'normal')
//       if (redLabel) doc.setTextColor(160, 30, 30)
//       doc.text(label, right - 32, y)
//       doc.text(value, amtX, y, { align: 'right' })
//       if (redLabel) doc.setTextColor(0, 0, 0)
//       y += 5
//     }

//     totRow('Sub Total :', `Rs ${money(subtotal)}`)

//     if (parcelChargeTotal > 0) {
//       const lbl = parcelQty > 0 ? `Parcel (${parcelQty}x) :` : 'Parcel Charge :'
//       totRow(lbl, `${money(parcelChargeTotal)}`)
//     }

//     if (additionalChargeTotal > 0) {
//       const lbl = parcelQty > 0 ? `Add.Charge(${parcelQty}):` : 'Addl. Charge :'
//       totRow(lbl, `Rs ${money(additionalChargeTotal)}`)
//     }

//     if (acChargeTotal > 0) {
//       totRow('AC Charge :', `Rs ${money(acChargeTotal)}`)
//     }

//     if (discount > 0) {
//       totRow('Discount :', `- Rs ${money(discount)}`, false, true)
//     }

//     if (tax > 0) {
//       totRow('Tax :', `Rs ${money(tax)}`)
//     }

//     // Grand Total
//     y += 1
//     dashedLine(doc, left, y, right)
//     y += 3

//     setFont(10, 'bold')
//     doc.text('Total Rs :', right - 32, y)
//     doc.text(`${Math.round(total)}`, amtX, y, { align: 'right' })
//     y += 3

//     // solidLine(doc, left, y, right)
//     // y += 2
//     // solidLine(doc, left, y, right)
//     // y += 5
//   }

//   // ── NOTE ──
//   if (note) {
//     if (!isKitchen) {
//       setFont(7.5, 'bold')
//       doc.text('NOTE', left, y)
//       y += 4
//     } else {
//       dashedLine(doc, left, y, right)
//       y += 4
//       setFont(8, 'bold')
//       doc.text('NOTE', left, y)
//       y += 4
//     }
//     setFont(7.5, 'normal')
//     doc.splitTextToSize(String(note), usableWidth).forEach((line) => {
//       doc.text(line, left, y)
//       y += 4
//     })
//     y += 2
//   }

//   dashedLine(doc, left, y, right)
//   y += 5

//   // ── FOOTER ──
//   if (!isKitchen) {
//     setFont(7, 'normal')
//     doc.text('GSTIN-', left, y)
//     if (hotel.gst) doc.text(hotel.gst, left + 13, y)
//     doc.text(`(${printTime})`, right, y, { align: 'right' })
//     y += 4
//     doc.text('VAT NO.-', left, y)
//     y += 4
//     doc.text('FSSAI NO-', left, y)
//     y += 4
//     doc.text('E.&O.E.', left, y)
//     y += 5
//   }

//   setFont(9, 'bold')
//   doc.text(
//     isKitchen ? 'Prepare order carefully' : 'Thank you for dining with us!',
//     center, y, { align: 'center' }
//   )
//   y += 5

//   if (!isKitchen) {
//     setFont(7.5, 'normal')
//     doc.text('Visit Again', center, y, { align: 'center' })
//   }

//   if (openInNewTab) {
//     window.open(doc.output('bloburl'), '_blank')
//   } else {
//     doc.save(`${isKitchen ? 'Kitchen' : 'Bill'}-${billNo}.pdf`)
//   }
// }

import jsPDF from 'jspdf'

const DEFAULT_HOTEL = {
  name: '',
  subtitle: '',
  address: '',
  phone: '',
  gst: '',
  vat: '',
  fssai: '',
  footerTitle: '',
  footerSubtitle: '',
  terms: '',
}

const formatDateTime = (d = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0')
  const hours = d.getHours()
  const h12 = hours % 12 || 12
  const ampm = hours >= 12 ? 'PM' : 'AM'

  return {
    date: `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${String(
      d.getFullYear()
    ).slice(2)}`,
    time: `${pad(h12)}:${pad(d.getMinutes())} ${ampm}`,
  }
}

const money = (value) => {
  const num = Number(value || 0)
  return num % 1 === 0 ? String(num) : num.toFixed(2)
}

const dashedLine = (doc, x1, y, x2) => {
  doc.setDrawColor(0)
  doc.setLineWidth(0.2)

  const dashLen = 1.4
  const gapLen = 1.1
  let cx = x1

  while (cx < x2) {
    doc.line(cx, y, Math.min(cx + dashLen, x2), y)
    cx += dashLen + gapLen
  }
}

const solidLine = (doc, x1, y, x2) => {
  doc.setDrawColor(0)
  doc.setLineWidth(0.25)
  doc.line(x1, y, x2, y)
}

export const generateBillPdf = ({
  type = 'normal',
  hotel = DEFAULT_HOTEL,
  bill = {},
  tableId,
  items = [],

  subtotal = 0,
  discount = 0,
  tax = 0,
  total = 0,

  parcelChargeTotal = 0,
  additionalChargeTotal = 0,
  acChargeTotal = 0,

  drinkVatAmount =0,

  drinkSubtotal = 0,
  drinkCgst = 0,
  drinkSgst = 0,
  drinkTotal = 0,

  note = '',
  paymentMode = 'Cash',
  openInNewTab = true,
}) => {
  if (!items.length) return

  const isDuplicate = type === 'duplicate'
  const isKitchen = type === 'kitchen'

  const pageWidth = 80
  const left = 5
  const right = pageWidth - 5
  const center = pageWidth / 2
  const usableWidth = pageWidth - 10

  const foodItems = items.filter((i) => Number(i.is_drink || 0) !== 1)
  const liquorItems = items.filter((i) => Number(i.is_drink || 0) === 1)
  const printItems = isKitchen ? items : [...foodItems, ...liquorItems]
  const discountValue = Math.abs(Number(discount || 0))

  const parcelQty = foodItems.reduce(
    (sum, item) =>
      sum + (Number(item.is_parcel || 0) === 1 ? Number(item.qty || 0) : 0),
    0
  )

  // 🔹 CALCULATE DRINK TOTAL: drinkSubtotal + drinkCgst + drinkSgst
  const calculatedDrinkTotal = Number(drinkSubtotal || 0) + Number(drinkCgst || 0) + Number(drinkSgst || 0) + Number(drinkVatAmount ||0 )

  const noteHeight = note ? 16 : 0
  const liquorBlockHeight = !isKitchen && Number(drinkSubtotal || 0) > 0 ? 38 : 0
  const baseHeight = isKitchen
    ? 82 + noteHeight
    : 155 + liquorBlockHeight + noteHeight
  const pageHeight = baseHeight + printItems.length * 7

  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: [pageWidth, pageHeight],
  })

  const setFont = (size = 8, style = 'normal') => {
    doc.setFont('courier', style)
    doc.setFontSize(size)
  }

  doc.setTextColor(0)

  const { date: printDate, time: printTime } = formatDateTime(new Date())
  const billNo = bill?.bill_no || `BILL-${bill?.id || '000'}`
  const tableName = bill?.table_name || `Table ${tableId || '0'}`

  let y = 8

  setFont(13, 'bold')
  doc.text((hotel.name || '').toUpperCase(), center, y, { align: 'center' })
  y += 5

 if (hotel.subtitle) {
  setFont(8, 'bold')
  doc.text(hotel.subtitle, center, y, { align: 'center' })
  y += 4
}

   setFont(8, 'normal')
  doc.splitTextToSize(hotel.address || '', usableWidth).forEach((line) => {
    doc.text(line, center, y, { align: 'center' })
    y += 4
  })

  if (hotel.phone) {
    setFont(8, 'normal')
    doc.text(hotel.phone, center, y, { align: 'center' })
    y += 4
  }

  y += 1
  dashedLine(doc, left, y, right)
  y += 4

  if (isDuplicate) {
    setFont(8, 'bold')
    doc.text('** DUPLICATE COPY **', center, y, { align: 'center' })
    y += 4
    dashedLine(doc, left, y, right)
    y += 4
  }

  setFont(8, 'normal')
  doc.text(isKitchen ? 'Kitchen Order' : 'Cash Memo', center, y, {
    align: 'center',
  })
  y += 5

  dashedLine(doc, left, y, right)
  y += 4

  setFont(7.5, 'normal')
  doc.text(`Date : ${printDate}`, left, y)
  doc.text(`Bill No : ${billNo}`, right, y, { align: 'right' })
  y += 5

  doc.text(`T.No : ${tableName}`, left, y)

  if (!isKitchen) {
    doc.text(`Payment : ${paymentMode}`, right, y, { align: 'right' })
  }


  y += 5
  dashedLine(doc, left, y, right)
  y += 4

  const qtyX = right - 30
  const rateX = right - 16
  const amtX = right

  setFont(8, 'bold')
  doc.text('Particulars', left, y)

  if (isKitchen) {
    doc.text('QTY', amtX, y, { align: 'right' })
  } else {
    doc.text('Qty', qtyX, y, { align: 'center' })
    doc.text('Rate', rateX, y, { align: 'center' })
    doc.text('Amount', amtX, y, { align: 'right' })
  }

  y += 2
  solidLine(doc, left, y, right)
  y += 4

  const printRow = (item) => {
    const isParcel = Number(item.is_parcel || 0) === 1
    const itemName = `${item.name || '-'}${isParcel ? ' (Parcel)' : ''}`

    const qty = Number(item.qty || 0)
    const rate = Number(item.price || 0)
    const amount = qty * rate

    const nameColWidth = isKitchen ? usableWidth - 10 : qtyX - left - 2
    const nameLines = doc.splitTextToSize(itemName, nameColWidth)
    const lastLineY = y + (nameLines.length - 1) * 4

    setFont(8, 'normal')

    nameLines.forEach((line, index) => {
      doc.text(line, left, y + index * 4)
    })

    if (isKitchen) {
      setFont(8, 'bold')
      doc.text(money(qty), amtX, y, { align: 'right' })
      setFont(8, 'normal')
    } else {
      doc.text(money(qty), qtyX, lastLineY, { align: 'center' })
      doc.text(money(rate), rateX, lastLineY, { align: 'center' })
      doc.text(money(amount), amtX, lastLineY, { align: 'right' })
    }

    y += nameLines.length * 4 + 1
  }

  if (isKitchen) {
    printItems.forEach(printRow)
  } else if (foodItems.length > 0) {
    foodItems.forEach(printRow)
  }

  if (!isKitchen) {

        if (foodItems.length > 0) {

          
    y += 2
    dashedLine(doc, left, y, right)
    y += 4
        }
    const labelX = right - 38

    const totalRow = (label, value, bold = false, danger = false) => {
      setFont(8, bold ? 'bold' : 'normal')

      if (danger) doc.setTextColor(180, 0, 0)

      doc.text(label, labelX, y)
      doc.text(value, amtX, y, { align: 'right' })

      if (danger) doc.setTextColor(0)

      y += 5
    }

    const foodBase =
      Number(subtotal || 0) +
      Number(parcelChargeTotal || 0) +
      Number(additionalChargeTotal || 0) +
      Number(acChargeTotal || 0)

    const foodCgst = foodItems.reduce(
      (sum, item) => sum + Number(item.item_cgst_amount || 0),
      0
    )

    const foodSgst = foodItems.reduce(
      (sum, item) => sum + Number(item.item_sgst_amount || 0),
      0
    )

    const foodTax = foodCgst + foodSgst

    const foodCgstPct =
      foodItems.find((i) => Number(i.item_cgst_pct || 0) > 0)?.item_cgst_pct || 0

    const foodSgstPct =
      foodItems.find((i) => Number(i.item_sgst_pct || 0) > 0)?.item_sgst_pct || 0

    const foodTotal = foodBase + foodTax

    if (foodItems.length > 0) {
      totalRow('Sub Total :', money(subtotal))
    }

    if (parcelChargeTotal > 0) {
      totalRow(
        parcelQty > 0 ? `Parcel (${parcelQty}x) :` : 'Parcel :',
        money(parcelChargeTotal)
      )
    }

    if (additionalChargeTotal > 0) {
      totalRow(
        parcelQty > 0 ? `Add.Charge(${parcelQty}):` : 'Add.Charge :',
        money(additionalChargeTotal)
      )
    }

    if (acChargeTotal > 0) {
      totalRow('AC Charge :', money(acChargeTotal))
    }

    if (foodItems.length > 0 && foodCgst > 0) {
      totalRow(
        `CGST @${money(foodCgstPct)}% On ${money(subtotal)} :`,
        money(foodCgst)
      )
    }

    if (foodItems.length > 0 && foodSgst > 0) {
      totalRow(
        `SGST @${money(foodSgstPct)}% On ${money(subtotal)} :`,
        money(foodSgst)
      )
    }

    const hasFood = foodItems.length > 0

    if (
      hasFood &&
      (
        Number(subtotal || 0) > 0 ||
        Number(parcelChargeTotal || 0) > 0 ||
        Number(additionalChargeTotal || 0) > 0 ||
        Number(acChargeTotal || 0) > 0
      )
    ) 
    {
      dashedLine(doc, labelX, y - 1, right)
      y += 3
      //totalRow('Food Total :', money(foodTotal), true)
    }
    if (liquorItems.length > 0) {
      y += 3
      dashedLine(doc, left, y, right)
      y += 5

      liquorItems.forEach(printRow)

      y += 2
      dashedLine(doc, labelX, y - 1, right)
      y += 4

      totalRow('Sub Total :', money(drinkSubtotal))

      if (Number(drinkCgst || 0) > 0) {
        totalRow('CGST :', money(drinkCgst))
      }

      if (Number(drinkSgst || 0) > 0) {
        totalRow('SGST :', money(drinkSgst))
      }
     
      if (Number(drinkVatAmount || 0) > 0) {
        totalRow('Vat :', money(drinkVatAmount))
      }

      dashedLine(doc, labelX, y - 1, right)
      y += 3

      totalRow('Liquor Total :', money(calculatedDrinkTotal), true)
    }

    y += 2
   // dashedLine(doc, left, y, right)
    //y += 5

    // 🔹 FIXED: Calculate grand total as sum of food total and calculated drink total
    const grandTotal = foodTotal + calculatedDrinkTotal - discountValue
    const roundedTotal = Math.round(grandTotal)
    const roundDiff = roundedTotal - grandTotal

    if (discountValue > 0) {
      totalRow('Discount :', `- ${money(discountValue)}`, false, true)
      dashedLine(doc, labelX, y - 1, right)
      y += 3
    }

    setFont(10, 'bold')
    doc.text('Total Rs :', labelX, y)
    doc.text(money(roundedTotal), amtX, y, { align: 'right' })
    y += 5

    if (roundDiff !== 0) {
      const sign = roundDiff > 0 ? '+' : ''
      setFont(7.5, 'normal')
      doc.text('Rnd Amt :', labelX, y)
      doc.text(`${sign}${money(roundDiff)}`, amtX, y, { align: 'right' })
      y += 4
    }

  
  }

  if (note) {
    if (!isKitchen) {
      setFont(8, 'bold')
      doc.text('NOTE', left, y)
      y += 4
    } else {
      dashedLine(doc, left, y, right)
      y += 4
      setFont(8, 'bold')
      doc.text('NOTE', left, y)
      y += 4
    }

    setFont(7.5, 'normal')
    doc.splitTextToSize(String(note), usableWidth).forEach((line) => {
      doc.text(line, left, y)
      y += 4
    })

    y += 2
  }

  dashedLine(doc, left, y, right)
  y += 5

  if (!isKitchen) {
    setFont(7, 'normal')

     doc.text('GSTIN -', left, y)
    doc.text(hotel.gst || '', left + 15, y)

    doc.text(`(${printTime})`, right, y, { align: 'right' })
    y += 4

    doc.text('VAT NO -', left, y)
    doc.text(hotel.vat || '', left + 15, y)
    y += 4

    doc.text('FSSAI -', left, y)
    doc.text(hotel.fssai || '', left + 15, y)
    y += 4
  }

  setFont(9, 'bold')
      doc.text(
      isKitchen
        ? 'Prepare order carefully'
        : hotel.footerTitle || 'Thank You',
      center,
      y,
      { align: 'center' }
    )
  y += 5

  if (!isKitchen) {
    setFont(7.5, 'normal')
   doc.text(hotel.footerSubtitle || 'Visit Again', center, y, {
  align: 'center',
})
  }

  // if (openInNewTab) {
  //   window.open(doc.output('bloburl'), '_blank')
  // } else {
  //   doc.save(`${isKitchen ? 'Kitchen' : 'Bill'}-${billNo}.pdf`)
  // }
 if (openInNewTab) {
  try {
    const blobUrl = doc.output('bloburl')

    const iframe = document.createElement('iframe')
    iframe.style.position = 'fixed'
    iframe.style.right = '0'
    iframe.style.bottom = '0'
    iframe.style.width = '0'
    iframe.style.height = '0'
    iframe.style.border = 'none'

    iframe.src = blobUrl
    document.body.appendChild(iframe)

    iframe.onload = () => {
      try {
        iframe.contentWindow.focus()

        // Attempt print
        iframe.contentWindow.print()

        // NOTE: If browser blocks silent print,
        // it will still show dialog automatically
      } catch (err) {
        // fallback
        doc.autoPrint()
        window.open(blobUrl, '_blank')
      }
    }
  } catch (e) {
    // fallback
    doc.autoPrint()
    window.open(doc.output('bloburl'), '_blank')
  }
} else {
  doc.save(`${isKitchen ? 'Kitchen' : 'Bill'}-${billNo}.pdf`)
}
}
